/* eslint-disable react/jsx-key */
import React from 'react'
import DetailChart from '../component/DetailLineChart'
import VChart from '../component/VChart'
import { fromNullable } from 'data.maybe'

const VerticalView = props => {
  const { valueKeys, unitMap, contentWidth, contentHeight, margin, colorScale, maxValue } = props

  const { selected, ...topProps } = props

  const topHeight = (contentHeight - 20) / 2.5

  const detailProps = {
    valueKeys,
    unitMap,
    contentWidth,
    contentHeight: contentHeight - topHeight - 30,
    margin,
    colorScale,
    maxValue,
  }

  return (
    <div>
      <VChart {...topProps} topHeight={topHeight} />
      {fromNullable(selected)
        .map(s => <DetailChart {...s} {...detailProps} />)
        .getOrElse(null)}
    </div>
  )
}

export default VerticalView
